module.exports = __webpack_public_path__ + "static/media/Pouting.ec1a242e.png";